import { Fragment } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Link from "next/link";
import { useRouter } from "next/router";

import { useI18n } from "@/i18n/I18nProvider";
import { useLanguageSwitcher } from "@/hooks/useLanguageSwitcher";
import { arFont, enFont } from "@/styles/font";
import { colors } from "@/utils/const";

import { styless } from "./user_dropDown";

const MENU_DIVIDER_IMAGE =
  "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/line.png";

const ACCOUNT_LINKS = [
  { href: "/profile", label: (t) => t.userNav.profile },
  { href: "/contract", label: (t) => t.userNav.your_installement },
  { href: "/customerservices", label: (t) => t.userNav.call_center },
];

/* The account area already offers the switch in its own header. */
const ACCOUNT_PATHS = new Set(["/contract", "/profile", "/customerservices"]);

/* The panel behind the avatar button. */
export default function UserMenu({ onClose, onLogout }) {
  const { t, locale } = useI18n();
  const router = useRouter();
  const { toggleLanguage } = useLanguageSwitcher();

  const handleLogout = () => {
    onClose();
    onLogout();
    localStorage.removeItem("bro-to");
  };

  return (
    <Box
      dir={locale === "en" ? "ltr" : "rtl"}
      className={locale === "en" ? enFont.className : arFont.className}
      sx={{
        boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
        borderRadius: "5px",
        bgcolor: colors.white,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        overflow: "hidden",
        width: locale === "en" ? "240px" : "180px",
      }}
    >
      <Box
        component="img"
        src={MENU_DIVIDER_IMAGE}
        alt=""
        aria-hidden="true"
        sx={{ width: "100%", height: "5px" }}
      />

      <Box
        sx={{
          p: { xs: 1, md: 2 },
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        {ACCOUNT_LINKS.map(({ href, label }, index) => (
          <Fragment key={href}>
            {index > 0 && <Box sx={styless.menuSeparator} />}
            <Box component={Link} href={href} sx={styless.menuItem}>
              {label(t)}
            </Box>
          </Fragment>
        ))}

        <Box sx={styless.menuSeparator} />
        <Box
          component={Link}
          href="/"
          onClick={handleLogout}
          sx={styless.menuItem}
        >
          {t.userNav.logout}
        </Box>

        {ACCOUNT_PATHS.has(router.pathname) && (
          <>
            <Box sx={styless.menuSeparator} />
            <Button
              aria-label="Change language"
              onClick={toggleLanguage}
              sx={{ ...styless.menuItem, p: 0, minWidth: "auto" }}
            >
              {t.main_nav.lang}
            </Button>
          </>
        )}
      </Box>
    </Box>
  );
}
